module.exports = __webpack_public_path__ + "img/np_mail_1535683_000000.caaa6df3.png";